<template>
  <div class="col-md-12">
    <Fullcalendar
      :header="{
        left: 'title',
        right: 'prev next'
      }"
      @eventClick="showEvent"
      :plugins="calendarPlugins"
      :events="events"
      locale="pt-br"
      @select="handleSelect"
    />
  </div>
</template>

<script>
import Fullcalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es'
import { mapGetters } from 'vuex'
import { get, map } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { warning } from '@/utils/alert'
import moment from 'moment'
import bus from '@/utils/eventBus'
import { schTime } from './dataTimes'

// today
const minDateNow = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
  return today
}

// 30 days after
const maxDateNow = () => {
  let beforedate = new Date()
  let priordate = new Date()
  priordate.setDate(beforedate.getDate() + 90)
  let dd2 = priordate.getDate()
  let mm2 = priordate.getMonth() + 1
  let yyyy2 = priordate.getFullYear()
  if (dd2 < 10) { dd2 = '0' + dd2 };
  if (mm2 < 10) { mm2 = '0' + mm2 };
  let datefrommonthago = yyyy2 + '-' + mm2 + '-' + dd2

  return datefrommonthago
}

export default {
  components: {
    Fullcalendar,
    Loading
  },
  data () {
    return {
      isLoading: true,
      onCancel: false,
      fullPage: true,
      common_area_id: null,
      disabled: false,
      canCancel: false,
      calendarPlugins: [dayGridPlugin, interactionPlugin],
      locale: esLocale,
      events: [],
      lockDates: [],
      toLock: [],
      newEvent: {
        event_name: '',
        title: null,
        start_date: '',
        end_date: '',
        tower_id: null,
        unit_id: null,
        list_visitor_id: null,
        common_area_id: null
      },
      addingMode: true,
      indexToUpdate: '',
      isMe: null,
      config: {
        minDate: minDateNow(),
        maxDate: maxDateNow(),
        sideBySide: true,
        useCurrent: false,
        locale: 'pt-br',
        format: 'DD/MM/YYYY',
        widgetPositioning: {
          horizontal: 'left',
          vertical: 'bottom'
        }
      },
      listGuest: [],
      dwellerTowers: [],
      selectDwellerUnits: [],
      common_area_name: null
    }
  },
  created () {
    this.getEvents()
    this.isMe = this.$store.state.user.id
  },
  methods: {
    ...mapGetters(['user']),
    formatTime (time) {
      moment.locale('pt-br')
      return get(schTime, moment(time).format('HH:mm'), moment(time).format('HH:mm'))
    },
    handleSelect (arg) {
      console.log(arg)
    },
    getCommonAreaById () {
      this.$http.get('/v1/search/dweller/area-common/' + this.newEvent.common_area_id)
      .then(({data}) => {
        this.common_area_name = data.name
      })
    },
    getTowersDweller () {
      this.$http.get('/v1/search/dweller/towers')
        .then((data) => {
          this.dwellerTowers = data.data
        })
    },
    selectTowerUnits (tower) {
      if (typeof tower === 'object') {
        this.$http.get('/v1/search/dweller/units/' + tower.id)
        .then((data) => {
          this.selectDwellerUnits = data.data
        })
      }

      if (typeof tower !== 'object') {
        this.$http.get('/v1/search/dweller/units/' + tower)
        .then((data) => {
          this.selectDwellerUnits = data.data
        })
      }
    },
    getListGuest () {
      this.$http.get('/v1/search/guest-list')
        .then(({data}) => {
          this.listGuest = data
        })
    },
    selectedListguest (list) {
      this.newEvent.list_visitor_id = list.id
    },
    addNewEvent () {
      this.$v.$touch()

      if (this.$v.$error) {
        return
      }

      const nEvent = {
        title: 'T:' + this.newEvent.tower_id + ' UND:' + this.newEvent.unit_id + ' - ' + this.common_area_name,
        event_name: this.newEvent.event_name,
        start_date: this.newEvent.start_date.split('/').reverse().join('-'),
        end_date: this.newEvent.start_date.split('/').reverse().join('-'),
        tower_id: this.newEvent.tower_id,
        unit_id: this.newEvent.unit_id,
        common_area_id: this.newEvent.common_area_id,
        common_area_name: this.common_area_name,
        list_visitor_id: this.newEvent.list_visitor_id,
        color: '#' + Math.floor(Math.random() * 16777215).toString(16)
      }
      this.isLoading = true
      this.$http
        .post('/v1/dweller/schedule-common-area', {
          ...nEvent
        })
        .then(({data, meta}) => {
          if (data.id) {
            this.isLoading = false
            this.getEvents()
            this.resetForm()
            this.$toast.success('Reserva incluida com sucesso, </br> Voce recebera um email com os detalhes.')
          }
          if (data.length <= 0) {
            this.isLoading = false
            warning(meta.message)
          }
        })
        .catch(({data, meta}) => {
        })
    },
    showEvent (arg) {
      this.addingMode = false
      const {
        id,
        event_name,
        start,
        owner,
        tower_id,
        unit_id,
        common_area_id,
        list_visitor_id,
        color
      } = this.events.find(
        event => event.id === +arg.event.id
      )
      if (owner === this.$store.state.user.id) {
        Promise.all([
          this.selectTowerUnits(tower_id)
        ])
        this.indexToUpdate = id
        this.newEvent = {
          event_name: event_name,
          start_date: start.split('-').reverse().join('/'),
          tower_id: tower_id,
          unit_id: unit_id,
          common_area_id: common_area_id,
          list_visitor_id: list_visitor_id,
          color: color
        }
        this.disabled = true
        this.$scrollTo('#toTop', 500)
      } else {
        this.$toast.warning(`Reservado  ${arg.event.title}`)
      }
    },
    updateEvent () {
      const toUpdate = {
        list_visitor_id: this.newEvent.list_visitor_id
      }
      this.$http
        .put('/v1/dweller/schedule-common-area/' + this.indexToUpdate, {
          ...toUpdate
        })
        .then(resp => {
          Promise.all([
            this.getEvents()
          ])
          this.addingMode = !this.addingMode
          this.$toast.success('Reserva atualizada com sucesso.')
        })
        .catch(err =>
          console.log('Unable to update event!', err.response.data)
        )
    },
    deleteEvent () {
      this.isLoading = true
      this.$http
        .delete('/v1/dweller/schedule-common-area/' + this.indexToUpdate)
        .then(resp => {
          Promise.all([
            this.resetForm(),
            this.getEvents()
          ])
          this.addingMode = !this.addingMode
          this.disabled = false
          this.isLoading = false
          this.$toast.success('Reserva excluida com sucesso. <br/> Voce recebera um email com os detalhes.')
        })
        .catch(err =>
          console.log('Unable to delete event!', err)
        )
    },
    getEvents () {
      if (this.common_area_id !== null) {
        bus.$emit('do-loading', {show: true})
        this.$http.get('/v1/dweller/schedules/' + this.common_area_id)
          .then((data) => {
            if (data.length >= 1) {
              const sch = map(data, (item) => {
                if (item.go_in === null) {
                  return {
                    id: item.id,
                    event_name: item.user_id === this.$store.state.user.id ? item.event_name : 'Não disponivel',
                    title: item.user_id === this.$store.state.user.id ? item.title : 'Não disponivel',
                    start: moment(item.start_date, 'YYYYMMDD').format('YYYY-MM-DD'),
                    end: moment(item.end_date, 'YYYYMMDD').format('YYYY-MM-DD'),
                    user_id: item.user_id,
                    common_area_id: item.common_area_id,
                    list_visitor_id: item.list_visitor_id,
                    color: item.color
                  }
                }
                if (item.go_in !== null) {
                  return {
                    id: item.id,
                    event_name: this.formatTime(item.go_in),
                    title: `${this.formatTime(item.go_in)} as ${this.formatTime(item.go_out)}`,
                    start: moment(item.start_date, 'YYYYMMDD').format('YYYY-MM-DD'),
                    end: moment(item.end_date, 'YYYYMMDD').format('YYYY-MM-DD'),
                    user_id: item.user_id,
                    common_area_id: item.common_area_id,
                    list_visitor_id: item.list_visitor_id,
                    color: item.color
                  }
                }
              })
              this.events = sch
              bus.$emit('do-loading', {show: false})
            } else {
              this.events = []
              bus.$emit('do-loading', {show: false})
            }
          })
          .catch(err => console.log(
              err.data
            )
          )
      }
    },
    resetForm () {
      Object.keys(this.newEvent).forEach(key => {
        return (this.newEvent[key] = '')
      })
    }
  },
  watch: {
    indexToUpdate () {
      return this.indexToUpdate
    }
  },
  mounted: function () {
    bus.$on('get-events-common-area', values => {
      this.common_area_id = values.id
      if (values.id !== null) {
        this.getEvents()
      }
    })

    const commonId = get(this.$route, 'query.common_id', null)
    this.newEvent.common_area_id = commonId
    Promise.all([
      // this.getListGuest(),
      // this.getTowersDweller()
    ])

    Promise.all([
      // this.getCommonAreaById()
    ])
  },
  validations: {
    newEvent: {
      event_name: {
        required
      },
      start_date: {
        required
      },
      tower_id: {
        required
      },
      unit_id: {
        required
      }
    }
  }
}
</script>

<style lang="css">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
<style scoped > .cursor-pointer {
  cursor: pointer;
}
.fc-next-button {
  background: #eee;
  color: #424242;
  font-size: 14px;
  border-radius: 30px !important;
  padding: 5px 6px;
  height: auto;
  border: none;
  box-shadow: none;
}
.fc-prev-button {
  background: #eee;
  color: #424242;
  font-size: 14px;
  border-radius: 30px !important;
  padding: 5px 6px;
  height: auto;
  border: none;
  box-shadow: none;
}
.fc-next-button,
.fc-prev-button {
  background: #eee;
  color: #424242;
  font-size: 14px;
  border-radius: 30px !important;
  padding: 5px 6px;
  height: auto;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.fc-next-button,
.fc-prev-button {
  background: #eee;
  color: #424242;
  font-size: 14px;
  border-radius: 30px !important;
  padding: 5px 6px;
  height: auto;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.fc .fc-view-container .fc-event {
  padding: 3px 5px;
  font-size: 10px;
  border-radius: 0.1875rem;
  background-color: #fff;
  border: 0;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/bookings/booking.vue